import React, { useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { site } from '../data/site';
const links = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Our Work',
  href: '#work'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Get a Quote',
  href: '#quote'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b-4 border-[#0B1B3A] bg-white" data-id="element-94" data-mp="1iq607b39kf9o">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-5 py-3 lg:px-10" data-id="element-95" data-mp="v0bowxyleyrj">
        <a href="#top" className="flex items-center gap-3" data-id="element-96" data-mp="qz089hxp5nvh">
          <img src={site.logo} alt="" className="h-12 w-12 object-contain lg:h-14 lg:w-14" data-id="element-97" data-mp="14x7xt4selmwm" />
          <span className="font-heading text-xl font-black uppercase leading-none tracking-tight text-[#0B1B3A] lg:text-2xl" data-id="element-98" data-mp="zzokq87fzg69">
            Rangel's
            <span className="block text-[0.6em] font-extrabold tracking-[0.25em] text-[#0B1B3A]/60" data-id="element-99" data-mp="2bbfo6cu7hlmn">
              Painting
            </span>
          </span>
        </a>

        <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-100" data-mp="2ein2xu21r38v">
          {links.map(link => <a key={link.href} href={link.href} className="font-heading text-sm font-bold uppercase tracking-widest text-[#0B1B3A] hover:text-[#0B1B3A]/60" data-id="element-101" data-mp="2jhq8dflxvbhd">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-102" data-mp="1vs5ngr68645g">
          <a href={site.phoneHref} className="hidden items-center gap-2 bg-[#0B1B3A] px-5 py-3 font-heading text-sm font-black uppercase tracking-widest text-white hover:bg-[#132a5c] sm:flex" data-id="element-103" data-mp="1vsx6z3mjsbfd">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="25k1oob3lyadw" />
            {site.phone}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="border-2 border-[#0B1B3A] p-2.5 text-[#0B1B3A] lg:hidden" data-id="element-105" data-mp="181080d475dvo">
            {open ? <X className="h-5 w-5" data-id="element-106" data-mp="101vaz83v52nm" /> : <Menu className="h-5 w-5" data-id="element-107" data-mp="1er1gfdtanp3y" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Mobile" className="border-t-2 border-[#0B1B3A]/10 bg-white px-5 pb-5 lg:hidden" data-id="element-108" data-mp="19ryfa4gfq319">
          <ul className="divide-y divide-[#0B1B3A]/10" data-id="element-109" data-mp="m3f2pcqcr43d">
            {links.map(link => <li key={link.href} data-id="element-110" data-mp="h42eanju1oyo">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-4 font-heading text-base font-black uppercase tracking-widest text-[#0B1B3A]" data-id="element-111" data-mp="h53sv2024tl5">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href={site.phoneHref} className="mt-4 flex items-center justify-center gap-2 bg-[#FACC15] px-5 py-4 font-heading text-base font-black uppercase tracking-widest text-[#0B1B3A]" data-id="element-112" data-mp="22gvtnwhizfoq">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="2ezhme0hp23bm" />
            Call {site.phone}
          </a>
        </nav>}
    </header>;
}